import React, { useState } from 'react';
import { Button, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import * as Yup from 'yup';
import TeamTable from '../components/TeamTable';
import TeamFormPopup from '../components/TeamFormPopup';

const TeamPage = () => {
  useDocumentTitle('Member Section');
  const [open, setOpen] = useState(false);

  return (
    <>
      <Grid container sx={{ justifyContent: 'end', pb: '1rem' }}>
        <Button variant="contained" onClick={() => setOpen(true)}>
          Add User
        </Button>
      </Grid>

      <TeamTable />

      <TeamFormPopup open={open} handleClose={() => setOpen(false)} mode={'create'} />
    </>
  );
};

export default TeamPage;
